import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { computed } from "vue";
import { appStore, orgStore } from "@/hooks";
import {
  AttributeChip,
  FlexBox,
  PanelCard,
  TextButton,
  Typography,
} from "@/components/common";
import SaveOrganizationInputs from "./SaveOrganizationInputs.vue";


/**
 * Displays an organization.
 */
const __default__ = {
  name: "OrganizationDisplay",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const editMode = computed(() => appStore.popups.saveOrg);

const org = computed(() => orgStore.org);

const teamCount = computed(() => orgStore.org.teams.length + " Teams");
const memberCount = computed(() => orgStore.org.members.length + " Members");
const projectCount = computed(
  () =>
    orgStore.org.teams
      .map(({ projects }) => projects.length)
      .reduce((a, b) => a + b, 0) + " Projects"
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PanelCard), {
    title: org.value.name
  }, {
    "title-actions": _withCtx(() => [
      (editMode.value)
        ? (_openBlock(), _createBlock(_unref(TextButton), {
            key: 0,
            text: "",
            label: "Cancel",
            icon: "cancel",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(appStore).close('saveOrg')))
          }))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      (!editMode.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_unref(FlexBox), { "full-width": "" }, {
              default: _withCtx(() => [
                _createVNode(_unref(AttributeChip), { value: teamCount.value }, null, 8, ["value"]),
                _createVNode(_unref(AttributeChip), { value: memberCount.value }, null, 8, ["value"]),
                _createVNode(_unref(AttributeChip), { value: projectCount.value }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_unref(Typography), {
              variant: "caption",
              value: "Description"
            }),
            _hoisted_2,
            _createVNode(_unref(Typography), {
              value: org.value.description
            }, null, 8, ["value"])
          ]))
        : (_openBlock(), _createBlock(SaveOrganizationInputs, { key: 1 }))
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})